import React, { useRef, useEffect } from 'react';

/**
 * FeedbackPanel - Real-time contextual explanations and end-of-game summary.
 */
const FeedbackPanel = ({ feedbackLog, isComplete, outcome, summary }) => {
  const scrollRef = useRef(null);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [feedbackLog]);

  const getTypeClass = (type) => {
    switch (type) {
      case 'danger':
      case 'critical': return 'feedback-danger';
      case 'warning': return 'feedback-warning';
      case 'success': return 'feedback-success';
      case 'intervention': return 'feedback-intervention';
      default: return 'feedback-info';
    }
  };

  const recentFeedback = feedbackLog.slice(-30);

  return (
    <div className="feedback-panel">
      <h3>System Log</h3>

      {isComplete && summary && (
        <div className={`game-summary ${outcome === 'win' ? 'summary-win' : 'summary-lose'}`}>
          <h4>{outcome === 'win' ? 'Hepatocyte Survived!' : 'Hepatocyte Lost'}</h4>
          <div className="summary-stats">
            <p>Cycles survived: <strong>{summary.ticksSurvived}</strong></p>
            <p>Final health: <strong>{summary.finalHealth.toFixed(1)}%</strong></p>
            <p>Mitochondrial integrity: <strong>{summary.finalMitoIntegrity.toFixed(1)}%</strong></p>
          </div>
          {summary.factors.length > 0 && (
            <div className="summary-factors">
              <h5>Key Factors:</h5>
              <ul>
                {summary.factors.map((factor, i) => (
                  <li key={i}>{factor}</li>
                ))}
              </ul>
            </div>
          )}
          {outcome === 'win' && (
            <p className="summary-message">
              The hepatocyte successfully cleared all acetaminophen and maintained cellular integrity.
              The detoxification pathways were sufficient to handle the toxic load.
            </p>
          )}
          {outcome === 'lose' && (
            <p className="summary-message">
              The hepatocyte suffered irreversible damage. NAPQI accumulation overwhelmed
              the cell's protective mechanisms, leading to oxidative stress and mitochondrial collapse.
            </p>
          )}
        </div>
      )}

      <div className="feedback-log" ref={scrollRef}>
        {recentFeedback.length === 0 && (
          <div className="feedback-empty">
            Administer a dose to begin the simulation...
          </div>
        )}
        {recentFeedback.map((entry, i) => (
          <div key={i} className={`feedback-entry ${getTypeClass(entry.type)}`}>
            <span className="feedback-tick">t={entry.tick}</span>
            <span className="feedback-message">{entry.message}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FeedbackPanel;
